export default {
  metadata: {
    version: '1.0.0',
    id: 'breadcrumbs-1.0.0',
    name: 'JDSBreadcrumbs',
    platform: 'web',
    description:
      "Breadcrumbs are a navigation system used to show hierarchy and navigational context for a user's location on a website. It helps users to understand where they are within a website's structure and move between levels.",
    usage:
      'Breadcrumbs are used to categorize information in the search results and thus help the SEO of the site.'
  },
  hierarchy: {
    container: [
      {
        'link-container': [
          'jds_link',
          {
            'jds-icon-container': ['jds-icon']
          }
        ]
      },
      'jds-text',
      'jds_menu_block'
    ]
  },
  base: {
    container: {
      'flex-direction': '{b_0}',
      'justify-content': '{b_1}',
      'align-items': '{b_2}',
      height: '{b_3}'
    },
    'link-container': {
      'flex-direction': '{b_4}',
      'justify-content': '{b_5}',
      'align-items': '{b_6}'
    },
    'jds-icon': {
      size: '{icon_5}',
      color: '{icon_15}',
      value: 'ic_chevron_right',
      ic: 'ic_chevron_right'
    },
    'jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_2}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}',
      ic: 'ic_chevron_right'
    },
    'jds-text': {
      'font-family': '{text_137}',
      color: '{text_21}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {},
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      'link-container': {
        value: {
          type: 'list',
          name: 'shownLinks',
          object: {
            newTab: 'boolean',
            href: 'string',
            title: 'string',
            routerLinkProps: 'object',
            provider: 'object',
            onClick: 'event'
          }
        }
      },
      jds_link: {
        title: {
          type: 'string',
          name: 'shownLinks.title'
        },
        newTab: {
          type: 'string',
          name: 'shownLinks.newTab',
          platform: 'web'
        },
        href: {
          type: 'string',
          name: 'shownLinks.href'
        },
        routerLinkProps: {
          type: 'RouterLinkProps',
          name: 'shownLinks.routerLinkProps',
          platform: 'angular'
        },
        onClick: {
          type: 'event',
          name: 'shownLinks.onClick'
        },
        provider: {
          type: 'event',
          name: 'shownLinks.provider',
          platform: 'react'
        }
      },
      jds_menu_block: {
        items: {
          type: 'list',
          name: 'hiddenLinks'
        },
        open: {
          type: 'boolean',
          name: 'open'
        },
        maxWidth: {
          type: 'size',
          name: 'maxWidth'
        },
        offsetX: {
          type: 'size',
          name: '_offsetX'
        },
        offsetY: {
          type: 'size',
          name: '_offsetY'
        },
        maxHeight: {
          type: 'size',
          name: '_maxHeight'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'currentPage'
        }
      }
    },
    events: {
      jds_link: {
        onClick: 'onClick'
      },
      jds_menu_block: {
        onSelect: 'onSelect',
        onClose: 'onClose'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'navigation'
          }
        }
      },
      'link-container': {
        name: 'shownLinks',
        repeating: {
          ariaLabel: 'linkAriaLabel',
          ariaDescribedby: {
            name: 'linkAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_link: {
        properties: {
          ariaLabel: 'shownLinks.linkAriaLabel',
          ariaDescribedby: 'shownLinks.linkAriaDescribedby'
        }
      }
    }
  }
};
